var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_12_1",
    "data-name": "Composant 12 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.234,
    height: 91.956,
    viewBox: "0 0 105.234 91.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Composant_11_1",
    "data-name": "Composant 11 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_723",
    "data-name": "Groupe 723",
    transform: "translate(-543.573 -763.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_722",
    "data-name": "Groupe 722",
    transform: "translate(543.573 765.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2156",
    "data-name": "Trac\\xE9 2156",
    d: "M621.317,881.932a.839.839,0,0,1-.839-.839V825.846a.839.839,0,0,1,1.678,0v55.246A.839.839,0,0,1,621.317,881.932Z",
    transform: "translate(-577.453 -791.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2157",
    "data-name": "Trac\\xE9 2157",
    d: "M621.317,912.134a.839.839,0,0,1-.3-1.623l44.309-16.892a.839.839,0,0,1,.6,1.568l-44.308,16.892A.828.828,0,0,1,621.317,912.134Z",
    transform: "translate(-577.453 -821.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2158",
    "data-name": "Trac\\xE9 2158",
    d: "M621.317,814.755a.839.839,0,0,1-.279-1.631l43.988-15.48a.839.839,0,1,1,.558,1.583L621.6,814.707A.852.852,0,0,1,621.317,814.755Z",
    transform: "translate(-577.453 -779.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2159",
    "data-name": "Trac\\xE9 2159",
    d: "M700.517,852.963a.839.839,0,0,1-.839-.839V798.435a.839.839,0,0,1,1.678,0v53.689A.839.839,0,0,1,700.517,852.963Z",
    transform: "translate(-612.345 -779.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2160",
    "data-name": "Trac\\xE9 2160",
    d: "M587.437,814.04a.841.841,0,0,1-.3-.055L544.114,797.6a.839.839,0,0,1,.6-1.568l43.025,16.387a.839.839,0,0,1-.3,1.624Z",
    transform: "translate(-543.573 -778.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2161",
    "data-name": "Trac\\xE9 2161",
    d: "M587.647,912.134a.828.828,0,0,1-.308-.059l-42.757-16.892a.839.839,0,1,1,.617-1.561l42.756,16.892a.839.839,0,0,1-.308,1.62Z",
    transform: "translate(-543.784 -821.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2162",
    "data-name": "Trac\\xE9 2162",
    d: "M544.412,852.249a.839.839,0,0,1-.839-.839v-54.6a.839.839,0,0,1,1.678,0v54.6A.839.839,0,0,1,544.412,852.249Z",
    transform: "translate(-543.573 -778.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2163",
    "data-name": "Trac\\xE9 2163",
    d: "M544.412,784.27a.839.839,0,0,1-.308-1.62l43.025-16.995a.839.839,0,0,1,.616,1.561L544.72,784.211A.843.843,0,0,1,544.412,784.27Z",
    transform: "translate(-543.573 -765.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2164",
    "data-name": "Trac\\xE9 2164",
    d: "M665.625,785.177a.83.83,0,0,1-.314-.062L621,767.214a.839.839,0,1,1,.628-1.556l44.308,17.9a.839.839,0,0,1-.314,1.617Z",
    transform: "translate(-577.453 -765.596)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2165",
    "data-name": "Trac\\xE9 2165",
    d: "M572.429,820.942a.839.839,0,0,1-.839-.839V808.732a.839.839,0,0,1,1.678,0V820.1A.839.839,0,0,1,572.429,820.942Z",
    transform: "translate(-12.343 -18.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2166",
    "data-name": "Trac\\xE9 2166",
    d: "M593.217,828.288a.839.839,0,0,1-.839-.839V815.4a.839.839,0,0,1,1.678,0v12.046A.839.839,0,0,1,593.217,828.288Z",
    transform: "translate(-21.501 -21.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2167",
    "data-name": "Trac\\xE9 2167",
    d: "M584.059,834.3a.837.837,0,0,1-.3-.055l-11.63-4.407a.839.839,0,1,1,.594-1.569l11.63,4.407a.839.839,0,0,1-.3,1.624Z",
    transform: "translate(-12.343 -27.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2168",
    "data-name": "Trac\\xE9 2168",
    d: "M572.429,795.584a.839.839,0,0,1-.3-1.621l41.631-16.179a.839.839,0,0,1,.608,1.565l-41.632,16.179A.839.839,0,0,1,572.429,795.584Z",
    transform: "translate(-12.343 -5.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2169",
    "data-name": "Trac\\xE9 2169",
    d: "M593.217,803.6a.839.839,0,0,1-.295-1.625l42.726-16.056a.839.839,0,0,1,.59,1.571l-42.726,16.056A.838.838,0,0,1,593.217,803.6Z",
    transform: "translate(-21.501 -8.929)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2140",
    "data-name": "Trac\\xE9 2140",
    d: "M17.49,0A17.49,17.49,0,1,1,0,17.49,17.49,17.49,0,0,1,17.49,0Z",
    transform: "translate(70.253)",
    fill: "#f5c66e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2077",
    "data-name": "Trac\\xE9 2077",
    d: "M772.191,604.284l5.033,4.314,8.268-8.268",
    transform: "translate(-690.611 -586.804)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConfirm);
export default __webpack_public_path__ + "static/media/order_confirm.57afdb45e2bccacfff0e31b0c272180c.svg";
export { ForwardRef as ReactComponent };